<template>
  <div>
    <div v-if="totalPages <= 6" class="pagination">
      <div v-if="currentPage !== 0" class="pagination-arrow-container" @click="goToPage(currentPage - 1)">
        <Arrow class="previous-page" />
      </div>
      <div
        v-for="page in Math.min(6, totalPages)"
        :key="page"
        class="page-number"
        :class="{ active: currentPage === page - 1 }"
        @click="goToPage(page - 1)"
      >
        {{ page }}
      </div>
      <div v-if="currentPage !== totalPages - 1 && totalPages > 1" class="pagination-arrow-container">
        <Arrow class="next-page" @click="goToPage(currentPage + 1)" />
      </div>
    </div>
    <div v-else-if="totalPages > 6" class="pagination">
      <div v-if="currentPage !== 0" class="pagination-arrow-container" @click="goToPage(currentPage - 1)">
        <Arrow class="previous-page" />
      </div>
      <div class="page-number" :class="{ active: currentPage === 0 }" @click="goToPage(0)">1</div>
      <div
        v-if="(currentPage + 1 <= 2 || currentPage + 1 === 4) && totalPages > 2"
        class="page-number"
        :class="{ active: currentPage === 1 }"
        @click="goToPage(1)"
      >
        2
      </div>
      <div v-if="currentPage < 2 && totalPages > 3" class="page-number" @click="goToPage(2)">3</div>
      <div v-if="currentPage + 1 > 4" class="page-number pagination-points" @click="goToPage(currentPage)">...</div>
      <div
        v-if="currentPage >= 2 && currentPage + 2 < totalPages && totalPages > 6 && totalPages > 3"
        class="page-number"
        @click="goToPage(currentPage - 1)"
      >
        {{ currentPage }}
      </div>
      <div
        v-if="currentPage >= 2 && currentPage + 2 < totalPages && totalPages > 6 && totalPages > 3"
        class="page-number active"
        @click="goToPage(currentPage)"
      >
        {{ currentPage + 1 }}
      </div>
      <div
        v-if="currentPage >= 2 && currentPage + 2 < totalPages && totalPages > 6 && totalPages > 3"
        class="page-number"
        @click="goToPage(currentPage + 1)"
      >
        {{ currentPage + 2 }}
      </div>
      <div v-if="currentPage + 1 < totalPages - 3" class="page-number pagination-points" @click="goToPage(currentPage)">
        ...
      </div>
      <div
        v-if="currentPage + 1 >= totalPages - 1 && totalPages > 3"
        class="page-number"
        @click="goToPage(totalPages - 3)"
      >
        {{ totalPages - 2 }}
      </div>
      <div
        v-if="(currentPage + 1 >= totalPages - 1 || currentPage + 4 === totalPages) && totalPages > 3"
        class="page-number"
        :class="{ active: currentPage + 1 === totalPages - 1 }"
        @click="goToPage(totalPages - 2)"
      >
        {{ currentPage + 1 === totalPages ? currentPage : totalPages - 1 }}
      </div>
      <div
        v-if="totalPages > 1"
        class="page-number"
        :class="{ active: currentPage + 1 === totalPages }"
        @click="goToPage(totalPages - 1)"
      >
        {{ totalPages }}
      </div>
      <div v-if="currentPage !== totalPages - 1 && totalPages > 1" class="pagination-arrow-container">
        <Arrow class="next-page" @click="goToPage(currentPage + 1)" />
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from '@/assets/listing/arrow_accordion.svg';

export default {
  name: 'PaginationComponent',
  components: {
    Arrow,
  },
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  emits: ['goToPage'],
  data() {
    return {};
  },
  computed: {},
  methods: {
    goToPage(number) {
      this.$emit('goToPage', number);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

$layout-breakpoint-small: 512px;

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1000px;
  margin-bottom: 30px;
  .page-number,
  .pagination-arrow-container {
    cursor: pointer;
    box-sizing: border-box;
    height: 25px;
    width: 25px;
    text-align: center;
  }
  .pagination-arrow-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .page-number {
    padding: 3px;
    font-size: 14px;
    font-weight: 300;
    margin: 0 10px;
    &.active {
      font-weight: 700;
    }
    &.pagination-points {
      cursor: default;
    }
  }

  .previous-page {
    position: absolute;
    bottom: 3px;
    left: 1px;
    height: 100%;
    width: 100%;
    transform: rotate(90deg);
  }
  .next-page {
    position: absolute;
    top: 2px;
    right: 1px;
    height: 100%;
    width: 100%;
    transform: rotate(-90deg);
  }
  .page-number:not(.pagination-points):hover,
  .pagination-arrow-container:hover {
    background-color: colors.$hover-pagination;
    border-radius: 50%;
  }
}
@media screen and (max-width: $layout-breakpoint-small) {
  .pagination {
    display: none;
  }
}
</style>
